import { render, staticRenderFns } from "./PrivacyPortalExternal.vue?vue&type=template&id=4d9bceb2"
import script from "./PrivacyPortalExternal.vue?vue&type=script&lang=js"
export * from "./PrivacyPortalExternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports